'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useCareAndShareConfigs } from '@/hooks/react-query/care-and-share/use-configs'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { CareAndShareContainer } from './container'

import { Skeleton } from '@/components/ui/skeleton'

export const CareShareTypicalProject = () => {
  const t = useTranslations()

  const { data: careAndShareData, isLoading } = useCareAndShareConfigs()

  const projects = careAndShareData?.highlight_projects

  if (isLoading) {
    return <CareShareTypicalProjectSkeleton />
  }

  //bỏ những dự án không có ảnh
  const filteredProjects = projects?.filter((project) => project.image)

  if (!filteredProjects || filteredProjects.length === 0) {
    return null
  }

  return (
    <CareAndShareContainer className='md:!py-0'>
      <h2 className='text-center font-criteria text-2xl font-bold uppercase leading-8 text-neutral-900 lg:mb-8 lg:text-4xl lg:leading-13'>
        {t('care_and_share_hardcode.typical_project.title')}
      </h2>

      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          slidesToScroll: 1,
          loop: true,
        }}
        className='mt-4 w-full'
      >
        <CarouselContent className='ml-0'>
          {filteredProjects.map((project, index) => (
            <CarouselItem
              className='basis-full pl-4 first-of-type:pl-0 last-of-type:pr-3 lg:basis-1/2'
              key={index}
            >
              <Link href={project.href || '#'}>
                <div className='group block h-full w-full overflow-hidden rounded-2xl lg:rounded-3xl'>
                  <Image
                    src={ImageHelper.getImageUrl(project.image)}
                    alt={t(
                      'care_and_share_hardcode.typical_project.banner_alt'
                    )}
                    width={470}
                    height={220}
                    loading='lazy'
                    unoptimized
                    className='h-full w-full object-cover transition-all duration-300 group-hover:scale-105 max-lg:h-56'
                  />
                </div>
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </CareAndShareContainer>
  )
}

export const CareShareTypicalProjectSkeleton = () => {
  return (
    <CareAndShareContainer className='md:!py-0'>
      <div className='flex justify-center'>
        <Skeleton className='mb-4 h-8 w-64 lg:mb-8 lg:h-10 lg:w-96' />
      </div>

      <div className='mt-4 flex w-full gap-4 overflow-hidden'>
        <Skeleton className='lg:h-120 h-56 basis-full rounded-2xl lg:basis-1/2 lg:rounded-3xl' />
        <Skeleton className='h-120 hidden basis-1/2 rounded-3xl lg:block' />
      </div>
    </CareAndShareContainer>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
